import React, { useMemo } from "react";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { FaArrowRight } from "react-icons/fa";
import {
  getIndustryDetails,
  STATIC_INDUSTRIES_ORDER,
} from "../../../utils/industryData";

const IndustriesSection = () => {
  const { hierarchy: fetchedIndustries } = useSelector(
    (state) => state.industries,
  ) || { hierarchy: {} };

  const displayIndustries = useMemo(() => {
    return STATIC_INDUSTRIES_ORDER.map((key) =>
      getIndustryDetails(key, fetchedIndustries),
    );
  }, [fetchedIndustries]);

  return (
    <section className="industries-section py-3">
      <div className="container-fluid px-4 px-lg-5 py-5">
        <div className="position-relative mb-5 animate-fade-up text-center mx-auto">
          <h2
            className="fw-bold display-6 text-dark mb-4 section-title"
            style={{ lineHeight: "1.2" }}
          >
            Explore Markets Across Industries
          </h2>
          <p className="text-muted mb-4 section-subtitle">
            Every industry is influenced by a unique combination of market
            forces, technological innovation, regulatory developments, and
            competitive activity. Browse research developed to help you
            understand market trends, evaluate opportunities, and make informed
            business decisions.
          </p>
          <div className="d-none d-md-flex justify-content-end w-100">
            <Link
              to="/reports"
              className="text-decoration-none fw-bold"
              style={{ color: "#053b84" }}
            >
              View All Industries <FaArrowRight className="ms-1" />
            </Link>
          </div>
        </div>
        <div
          className="marquee-container overflow-hidden position-relative w-100"
          style={{ padding: "10px 0" }}
        >
          <div className="marquee-content d-flex">
            {[...displayIndustries, ...displayIndustries].map(
              (industry, index) => (
                <div
                  className="marquee-item px-3 flex-shrink-0"
                  style={{ width: "340px" }}
                  key={index}
                >
                  <div className="industry-image-card h-100 shadow-sm d-flex flex-column bg-white border">
                    <div
                      className="card-img-top overflow-hidden"
                      style={{ height: "160px" }}
                    >
                      <img
                        src={industry.image}
                        alt={industry.name}
                        className="w-100 h-100 object-fit-cover"
                        loading="lazy"
                      />
                    </div>
                    <div className="card-body p-4 d-flex flex-column text-start">
                      <h5 className="h5 fw-normal text-dark mb-2">
                        {industry.name}
                      </h5>
                      <p
                        className="text-muted small mb-3 flex-grow-1"
                        style={{
                          display: "-webkit-box",
                          WebkitLineClamp: 3,
                          WebkitBoxOrient: "vertical",
                          overflow: "hidden",
                          lineHeight: "1.6",
                        }}
                      >
                        {industry.description}
                      </p>
                      <Link
                        to={`/industries/${industry.slug}`}
                        className="text-decoration-none read-more-link fw-medium small mt-auto d-flex align-items-center"
                        aria-label={`Explore ${industry.name} Industry`}
                      >
                        Read More{" "}
                        <FaArrowRight
                          className="ms-1"
                          style={{ fontSize: "0.8rem" }}
                        />
                      </Link>
                    </div>
                  </div>
                </div>
              ),
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default IndustriesSection;
